export const STATS_STORAGE_KEY = 'stats';
